<template>
    <div>
        <h2>Learner Profile for {{learner.fullName ? learner.fullName : 'Unknown'}}</h2>
        <div class="header-links">
            <a :href="'/classroom/' + classroomID">
                <i>Classroom: {{classroomData.name}}</i>
            </a>
        </div>
        <br>
        <md-tabs>
            <md-tab md-label="Case Completion">
                <div v-for="(assignmentEntry, assignmentIndex) in classroomData.assignments" :key="assignmentIndex">
                    <b>Assignment #{{assignmentIndex+1}} - {{assignmentEntry.name}}</b>
                    <div style="border-radius: 25px; border: 1px solid black; overflow: hidden; margin: 15px;">
                        <div v-for="(caseID, caseIndex) in assignmentEntry.caseList" :key="caseIndex" 
                        :style="{'background-color': ((completionData[assignmentEntry.id] && completionData[assignmentEntry.id][caseID]) ? '#c3f5ce' : '#ffc0c0')}">
                            <div style="padding: 10px;">
                                {{caseData[caseID] ? caseData[caseID].title : "UNKNOWN"}}
                            </div>
                        </div>
                        <div v-if="assignmentEntry.caseList.length === 0">
                            <div ifstyle="padding: 10px;">
                                No cases have been added to this assignment yet.
                            </div>
                        </div>
                    </div>
                    <br>
                </div>
            </md-tab>
            <md-tab md-label="Case Performance" style="height: 600px;">
                <h2 class="md-title" style="margin-top: 10px; margin-bottom: 30px;">
                    Case Performance Breakdown                
                    <hr>
                </h2>
                <div v-if="classroomData.assignments && Object.keys(caseScores).length > 0">
                    <div v-for="(assignmentEntry, assignmentIndex) in classroomData.assignments.filter((x) => x.caseList.length > 0)" :key="assignmentIndex" style="margin-bottom: 30px">
                        <b>Assignment #{{assignmentIndex+1}} - {{assignmentEntry.name}}</b>
                        <md-table v-model="caseScores[assignmentEntry.id]" md-sort="name" md-sort-order="asc" md-fixed-header>
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <md-table-cell md-label="Case Name" md-sort-by="caseName">
                                    <router-link :to="'/classroom/' + classroomID + '/learner/' + item.pid">
                                        {{ item.caseName }}
                                    </router-link>
                                </md-table-cell>
                                <md-table-cell md-label="Time On Case" md-sort-by="timeOnCase">
                                    {{ (completionData[assignmentEntry.id] && completionData[assignmentEntry.id][item.cid]) ? (item.timeOnCase ? (item.timeOnCase / 60).toFixed(1) + " min." : "N/A") : "INCOMPLETE" }}
                                </md-table-cell>
                                <md-table-cell md-label="VBM Score" md-sort-by="vbmScore.totalCost">
                                    {{ (item.vbmScore.totalCost && item.vbmScore.maxCost) ?  "$" + item.vbmScore.totalCost + " out of $" + item.vbmScore.maxCost : "N/A"}}
                                </md-table-cell>
                                <md-table-cell md-label="Lab Score" md-sort-by="labScore">
                                    {{ item.labScore ? item.labScore + "%" : "N/A"}}
                                </md-table-cell>
                                <md-table-cell md-label="DDx Score" md-sort-by="ddxScore">
                                    {{ item.ddxScore ? item.ddxScore + "%" : "N/A"}}
                                </md-table-cell>
                                <md-table-cell md-label="Knowledge Score" md-sort-by="knowledgeScore">
                                    {{ item.knowledgeScore ? item.knowledgeScore + "%" : "N/A"}}
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                    </div>
                </div>
            </md-tab>
        </md-tabs>
    </div>
</template>

<script>
    import APIRequests from "../APIRequests.js"
    import ResponseDashboard from "./ResponseDashboard.vue"
    
    export default {
        components: {
            ResponseDashboard
        },
        props: {
            classroomID: {
                type: String
            },
            learnerID: {
                type: String
            },
        },
        computed: {
            learner: function(){
                let candidateList = this.classroomProfiles.filter((x) => x.pid == this.learnerID)
                if(candidateList.length != 1) return {fullName: "Unknown"}
                return candidateList[0]
            },
        },
        data: function(){
            return {
                classroomData: {},
                classroomProfiles: [],
                completionData: {},
                responseData: [],
                caseData: {},
                caseScores: {},
                editorMode: false,
            }
        },
        methods: {
            fetchClassroomData: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomID
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data.classroomData) data.classroomData = {assignments: []}
                    this.classroomData = data.classroomData
                    this.editorMode = data.editorMode
                    if(this.editorMode){ 
                        if(!data.classroomProfiles) data.classroomProfiles = []
                        this.classroomProfiles = data.classroomProfiles
                    }
                })
            },
            fetchCompletionData: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomID + "/completion/" + this.learnerID
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data) data={}
                    this.completionData = data
                })
            },
            fetchResponseData: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomID + "/responses/" + this.learnerID
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data) data=[]
                    this.responseData = data

                })
            },
            scoreCases: function(){
                this.caseScores = this.classroomData.assignments.reduce((agg, assignmentEntry) => {
                    if(!agg[assignmentEntry.id]) agg[assignmentEntry.id] = [];
                    assignmentEntry.caseList.forEach((caseID) => {
                        const firstAttempt = this.responseData.filter(resp => resp.cid == caseID && resp.reporting.assignmentID == assignmentEntry.id && resp.attempt == 1);
                        const timepoints = firstAttempt.map((resp) => resp.finishTime);
                        const firstTimepoint = Math.min(...timepoints)
                        const lastTimepoint = Math.max(...timepoints);
                        const timeOnCase = lastTimepoint - firstTimepoint;
                        // Run over each lab slide in the attempt and add up total spent as well as total possible to spend
                        const vbmScore = firstAttempt.filter((resp) => resp.slideType == "Labs").reduce((agg, resp) => {
                            if(resp.performance.Labs && resp.performance.Labs.totalCost && resp.performance.Labs.maxCost){
                                agg.totalCost += resp.performance.Labs.totalCost;
                                agg.maxCost += resp.performance.Labs.maxCost;
                            }
                            return agg;
                        }, {totalCost: 0, maxCost: 0});
                        // Sum up all scores on labs (determined by missed or unecessary lab purchases) and then take avg.
                        const calcQuestionAvgPct = function(slideType){
                            var totalScore = 0;
                            var totalPct = 0;
                            firstAttempt.forEach((responseElem) => {
                                if(responseElem.performance && Object.keys(responseElem.performance).includes(slideType)){
                                    totalScore += responseElem.score
                                    totalPct += 100
                                }
                                // Hack to include MC and checklist in knowledge score
                                if(slideType == "Checklist" && responseElem.performance && Object.keys(responseElem.performance).includes("Multiple Choice")){
                                    totalScore += responseElem.score
                                    totalPct += 100
                                }
                            })
                            return  100 * totalScore / totalPct
                        }
                        const labScore = calcQuestionAvgPct("Labs")
                        const ddxScore = calcQuestionAvgPct("Diagnosis")
                        const knowledgeScore = calcQuestionAvgPct("Checklist")
                        agg[assignmentEntry.id].push({cid: caseID, caseName: this.caseData[caseID].title, timeOnCase, vbmScore, labScore, ddxScore, knowledgeScore})
                    })
                    return agg;
                }, {});
            },
            fetchCaseData: function(){
                return Promise.all(this.classroomData.assignments.map((assignmentEntry) => {
                    return Promise.all(assignmentEntry.caseList.map((caseID) => {
                        if(this.caseData[caseID]) return
                        var api_url = this.$store.state.api_url + "/api/cases/" + caseID
                        return APIRequests.getJSONData(
                            api_url,
                            this.$store.state.jwtToken
                        ).then((data) => {
                            this.$set(this.caseData, caseID, data)
                        })
                    }))
                }))
            },
        },
        mounted: function(){
            this.$nextTick(function () {
                this.fetchClassroomData()
                .then(() => this.fetchCompletionData())
                .then(() => this.fetchResponseData())
                .then(() => this.fetchCaseData())
                .then(() => this.scoreCases())
            })
        }
    }
</script>

<style scoped>
    .header-links {
        display: flex;
        justify-content: space-around;
        max-width: 500px;
        margin: auto;
        margin-top: 24px;
    }
    .header-links a {
        color: black !important;
        font-weight: bold;
    }
</style>
